import { application } from "./application"

import CharacterCounterController from "./character_counter_controller"
import ColorSchemeController from "./color_scheme_controller"
import CopyPhraseController from "./copy_phrase_controller"
import FlashToastController from "./flash_toast_controller"
import KeyboardController from "./keyboard_controller"
import LiveActivityController from "./live_activity_controller"
import LiveStatsController from "./live_stats_controller"
import PageCacheController from "./page_cache_controller"
import ReportFormController from "./report_form_controller"
import ShareClickController from "./share_click_controller"
import TapTooltipController from "./tap_tooltip_controller"
import VotePillController from "./vote_pill_controller"

application.register("character-counter", CharacterCounterController)
application.register("color-scheme", ColorSchemeController)
application.register("copy-phrase", CopyPhraseController)
application.register("flash-toast", FlashToastController)
application.register("keyboard", KeyboardController)
application.register("live-activity", LiveActivityController)
application.register("live-stats", LiveStatsController)
application.register("page-cache", PageCacheController)
application.register("report-form", ReportFormController)
application.register("share-click", ShareClickController)
application.register("tap-tooltip", TapTooltipController)
application.register("vote-pill", VotePillController)
